import React from "react";
import { useDisplayGuarantee } from "../../../data/clearing/guarantees/hooks/useDisplayGuarantees";
import { DisplayDrawerContext } from "../../../layout/DisplayDrawerContext";
import {
  GuaranteeData,
  GuaranteeListData,
} from "../../../data/clearing/guarantees/types";
import { LocalizationContext } from "../../../core/localization/Localization";
import { DisplayGuaranteeMainAttributes } from "./DisplayGuaranteeMainAttributes";
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  Typography,
  Grid,IconButton,
} from "@material-ui/core";
import { CustomTooltip } from "../../components/common/CustomTooltip";
import DownloadIcon from "@material-ui/icons/CloudDownloadOutlined";
import { useGuaranteePrinter } from "../../../data/clearing/guarantees/hooks/useGuaranteePrinter";

export interface DisplayGuaranteeProps {
  id?: string;
}

export const DisplayGuarantee: React.FunctionComponent<DisplayGuaranteeProps> = ({
  id,
}) => {
  const guarantee = useDisplayGuarantee(id);
  const { getString } = React.useContext(LocalizationContext);
	const [download, fetchState, setfetch] = useGuaranteePrinter(guarantee);

  return !guarantee ? (
    <>{"loading placeholder"}</>
  ) : (
    <Grid container justify="center" direction="column">
      <ExpansionPanel expanded>
        <ExpansionPanelSummary>
        <Grid container justify="space-between">
            <Grid item>
              <Typography>{getString("tableBasciInfo")}</Typography>
            </Grid>
							<Grid item>
								<CustomTooltip titleKeyword="exportPDFTooltip">
									<IconButton
										color="secondary"
										component="span"
										onClick={download}
										disabled={fetchState.type !== "not-started"}
									>
										<DownloadIcon />
									</IconButton>
								</CustomTooltip>
                { fetchState.type !== "not-started"  ? getString("pleaseWait") : null }
							</Grid>
          </Grid>
        </ExpansionPanelSummary>
        <DisplayGuaranteeMainAttributes guarantee={guarantee} />
      </ExpansionPanel>
    </Grid>
  );
};


export const useViewGuarantee = () => {
  const showWithDrawer = React.useContext(DisplayDrawerContext);
  return React.useCallback(
    (guarantee: GuaranteeListData) =>
      showWithDrawer(<DisplayGuarantee id={guarantee.payId} />),
    [showWithDrawer]
  );
};
